import { Route, Routes } from "react-router-dom";
import { Dashboard, LoginPage } from "pages";
import { Suspense } from "react";
import { ProtectedRoute } from "utils";
import { ROUTE_ENUM } from "enums";

const RoutesComponent: React.FC = () => {
  return (
    <Suspense fallback={"..."}>
      <Routes>
        <Route path={"/"} element={<LoginPage />} />

        <Route
          path={ROUTE_ENUM.DASHBOARD}
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default RoutesComponent;
